import PrimarySideBar from '../../../components/common/sideBar/primarySideBar.js';
import AddButtonSection from '../../../components/common/AddButtonSection.js';
import RolePermissionEditor from './RolePermissionEditor.jsx';

/**
 * RolePermissionModal Component
 * Modal for assigning permissions to a role
 * 
 * @param {Boolean} visible - Controls modal visibility
 * @param {Function} onHide - Handler to close the modal
 * @param {Function} onSubmit - Handler for form submission
 * @param {Function} onCancel - Handler for cancel action
 * @param {Object} editRolePermission - Role object being edited
 * @param {Array} permissionsList - Total list of permissions
 * @param {Array} assignedPermissions - Currently assigned permissions
 * @param {Function} setAssignedPermissions - Setter for assigned permissions
 * @param {Array} availablePermissions - Available permissions to assign
 * @param {Function} setAvailablePermissions - Setter for available permissions
 * @param {Boolean} loading - Loading state
 */
export default function RolePermissionModal({
  visible,
  onHide,
  onSubmit,
  onCancel,
  editRolePermission,
  permissionsList,
  assignedPermissions,
  setAssignedPermissions,
  availablePermissions,
  setAvailablePermissions,
  loading,
}) {
  const buttons = [
    {
      type: "primarySuccessButton",
      label: "Submit",
      class: "col-4",
      disabled: assignedPermissions.length === 0 || loading,
      onClick: onSubmit,
    },
    {
      type: "primaryCancelButton",
      label: "Cancel",
      class: "col-4",
      onClick: onCancel,
    },
  ];

  return (
    <PrimarySideBar
      visible={visible}
      onHide={onHide}
      header={
        <div className="sideBar-header">
          <span className="capitalize">
            {editRolePermission?.title}
          </span>
        </div>
      }
      className={"w-40rem"}
    >
      <RolePermissionEditor
        totalList={permissionsList}
        idKey={"app_permission_id"}
        assignedPermissions={assignedPermissions}
        setAssignedPermissions={setAssignedPermissions}
        availablePermissions={availablePermissions}
        setAvailablePermissions={setAvailablePermissions}
      />
      <div className="pt-3">
        <AddButtonSection buttons={buttons} />
      </div>
    </PrimarySideBar>
  );
}

